import { CustomTileData } from 'features/layout/features/config/types';
import { SourceDetails } from 'features/layout/types';
import { formatCustomTileToSource } from 'utils/custom-tile/format';
import { useExpandControl } from './useExpandControl';

export const useCustomTileExpandControl = (
  data: CustomTileData,
  clickCallback: (e: React.MouseEvent<HTMLLIElement | HTMLButtonElement, MouseEvent>) => void
) => {
  const source: SourceDetails = formatCustomTileToSource(data);

  return useExpandControl(source, clickCallback);
};
